<!-- eslint-disable vue/no-duplicate-attributes -->
<template>
  <div class="view-container">
    <div class="header">
      <!-- Tab 切换 -->
      <div class="tab">
        <span
          class="tabItem"
          :class="{ active: active === 0 }"
          @click="handleTabClick(0)"
        >海运</span
        >
        <span
          class="tabItem"
          :class="{ active: active === 1 }"
          @click="handleTabClick(1)"
        >空运</span
        >
      </div>
      <div class="optheader">
        <!-- 导出按钮 -->
        <div
          v-permission="'export'"
          class="btn flex_c_c"
          style="margin-right: 12px"
          @click="handleExport"
        >
          <i class="el-icon-download" /> 导出
        </div>
        <!-- 搜索过滤器 -->
        <BaseFilter
          :is-active="isActive"
          :width="466"
          @sendFilter="handleSearchOk"
          @reset="handleSearchReset"
        >
          <div class="filter">
            <el-form ref="searchForm" :model="searchData" label-width="70px">
              <el-form-item label="客户">
                <el-select
                  v-model="searchData.companyId"
                  style="width: 310px"
                  filterable
                  multiple
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in companyOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="搜索">
                <el-input
                  v-model="searchData.search"
                  placeholder="提单号"
                  style="width: 320px"
                />
              </el-form-item>
            </el-form>
          </div>
        </BaseFilter>
      </div>
    </div>

    <div class="data">
      <el-tabs
        v-model="status"
        v-loading="loading"
        type="border-card"
        class="el-tabs"
        @tab-click="handleTabClick"
      >
        <el-tab-pane :label="`所有(${form.all})`" name="All" />
        <el-tab-pane :label="`未发送(${form.one})`" name="NotSent" />
        <el-tab-pane :label="`发送中(${form.two})`" name="Sending" />
        <el-tab-pane :label="`已发送(${form.three})`" name="HasBeenSent" />

        <div class="table">
          <BaseTable
            :key="status"
            :height="height"
            :table-data="{ ...list, fileds }"
            :page-number="pager.PageIndex"
            :page-size="pager.PageSize"
            @handlePageChange="handlePageChange"
            @dblclick="handleRowDoubleClick"
            @selection-change="handleSelectionChange"
          >
            <!-- 操作列 -->
            <template slot="opt" slot-scope="row">
              <el-popover
                :ref="`popover${row.scope.id}`"
                placement="bottom-start"
                popper-class="pop-table-opt"
                width="114"
                trigger="click"
              >
                <div class="table-opt">
                  <div>
                    <el-button
                      class="opt-item"
                      @click="handleCommand('firmcode', row.scope)"
                    >
                      Firmcode
                    </el-button>
                  </div>
                  <div>
                    <el-button
                      v-if="row.scope.firmCode != undefined && active === 0"
                      class="opt-item"
                      @click="handleCommand('sendAnEmail', row.scope)"
                    >
                      发送AN
                    </el-button>
                  </div>
                  <div>
                    <el-button
                      v-if="row.scope.firmCode != undefined"
                      class="opt-item"
                      @click="handleCommand('sendDoEmail', row.scope)"
                    >
                      发送DO
                    </el-button>
                  </div>
                </div>
                <img slot="reference" src="@/assets/images/table/opt.png" />
              </el-popover>
            </template>

            <!-- 文件数量列 -->
            <template slot="fileNumber" slot-scope="row">
              <i
                class="el-icon-folder-opened"
                style="color: black"
                @click="viewFile(row.scope)"
              >{{ row.scope.fileNumber }}</i
              >
            </template>
          </BaseTable>
        </div>
      </el-tabs>
    </div>

    <!-- 添加 FirmCode 弹窗 -->
    <el-dialog
      class="dialog"
      :visible.sync="dialogFormVisible"
      :title="'AN/DO记录添加FirmCode'"
      :destroy-on-close="true"
      :before-close="handleDialogClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="36%"
    >
      <el-form ref="form1" v-loading="loading2" :model="form1" :rules="rules1">
        <el-form-item
          label="清关行："
          prop="supplierClearenceId"
          style="margin-bottom: 2px"
        >
          <el-select
            v-model="form1.supplierClearenceId"
            style="width: 100%"
            placeholder="请输入选择清关行"
          >
            <el-option
              v-for="item in supplierOptions"
              :key="item.id"
              :label="item.code + '-' + item.wbName"
              :value="item.id"
            />
          </el-select>
        </el-form-item>

        <el-form-item
          label="FirmCode"
          prop="firmCode"
          style="margin-bottom: 2px"
        >
          <el-popover placement="right-end" trigger="hover">
            <pre>输入关键词为1111即可筛选空白FirmCode</pre>
            <el-button
              slot="reference"
              style="
                color: red;
                display: flex;
                margin-top: 5px;
                margin-bottom: 5px;
              "
              icon="el-icon-chat-dot-round"
              size="mini"
              circle
            />
          </el-popover>
          <el-select
            v-model="form1.firmCodeId"
            style="width: 100%"
            filterable
            clearable
            remote
            reserve-keyword
            placeholder="请输入关键词(至少3个字符)"
            popper-class="firmcode-select"
            :remote-method="remoteMethod"
            :loading="loading1"
            @focus="handleFocus"
          >
            <el-option
              v-for="item in firmCodeOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item
          v-if="active === 0"
          label="FirmCode替换地址信息"
          prop="firmCodeInformation"
          style="margin-bottom: 2px"
        >
          <el-input
            v-model="form1.firmCodeInformation"
            type="textarea"
            :rows="3"
            placeholder="公司名称 详细地址 城市地址 州地址 邮编"
          />
        </el-form-item>

        <el-form-item
          label="FORDELIVERYTO"
          prop="FORDELIVERYTO"
          style="margin-bottom: 2px"
        >
          <el-input
            v-model="form1.fordeLiveryTo"
            type="textarea"
            :rows="3"
            placeholder="公司名 详细地址 城市地址 省份地址 国家地址 邮编"
          />
        </el-form-item>

        <el-form-item
          v-if="active != 0"
          label="ENTRY"
          prop="ENTRY"
          style="margin-bottom: 2px"
        >
          <el-input
            v-model="form1.entry"
            type="textarea"
            :rows="1"
            placeholder="ENTRY"
          />
        </el-form-item>

        <el-form-item
          v-if="active != 0"
          label="remark"
          prop="remark"
          style="margin-bottom: 2px"
        >
          <el-input
            v-model="form1.remark"
            type="textarea"
            :rows="2"
            placeholder="备注"
          />
        </el-form-item>
      </el-form>

      <span
        slot="footer"
        class="dialog-footer"
        style="display: contents; padding-top: -10px"
      >
        <el-button @click="handleDialogClose">取 消</el-button>
        <el-button
          type="primary"
          :loading="loading2"
          @click="submitForm"
        >确 认</el-button
        >
      </span>
    </el-dialog>

    <!-- 发送邮件弹窗 -->
    <el-dialog
      class="dialog"
      :visible.sync="dialogFormVisible1"
      :title="title"
      :destroy-on-close="false"
      :before-close="ANAndDohandleDialogClose"
      width="36%"
      top="5vh"
      @opened="selectAllRows"
    >
      <el-form
        ref="form2"
        v-loading="loading"
        :model="form2"
        :rules="rules2"
        label-width="100px"
      >
        <el-form-item label="清关行：" prop="supplierClearenceId">
          <el-select
            v-model="form2.supplierClearenceId"
            style="width: 100%"
            filterable
            clearable
            placeholder="请输入选择清关行"
            @change="supplierCodeChange"
          >
            <el-option
              v-for="item in supplierOptions"
              :key="item.id"
              :label="item.code + '-' + item.wbName"
              :value="item.id"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="Email To" prop="receiver">
          <el-input
            v-model="form2.receiver"
            type="textarea"
            autosize
            autocomplete="off"
            :autosize="{ minRows: 1, maxRows: 4 }"
          />
        </el-form-item>

        <el-form-item label="CC：">
          <el-input
            v-model="form2.cc"
            type="textarea"
            autosize
            autocomplete="off"
            placeholder="请输入电子邮件地址"
            :autosize="{ minRows: 1, maxRows: 4 }"
            @blur="validateEmailList"
          />
        </el-form-item>
        <span v-if="validationError" style="color: red">{{
          validationError
        }}</span>

        <el-form-item label="主题" prop="title">
          <el-input
            v-model="form2.title"
            type="textarea"
            autosize
            show-word-limit
            :autosize="{ minRows: 1, maxRows: 4 }"
          />
        </el-form-item>

        <el-form-item label="正文" prop="content">
          <el-input
            v-model="form2.content"
            type="textarea"
            autosize
            show-word-limit
            :autosize="{ minRows: 2, maxRows: 4 }"
          />
        </el-form-item>

        <el-form-item label="请勾选需要发送的文件" label-width="240">
          <Table
            ref="customTable"
            :tableData="tableData1"
            :height="170"
            :pageFooter="false"
            @selectionchange="selectionchange2"
          >
            <template slot-scope="row">
              <el-button type="text" size="mini">
                <span
                  style="font-size: 12px"
                  @click="download(row.scope)"
                >下载</span
                >
              </el-button>
              <el-button
                v-if="
                  ['.pdf', '.PDF', '.JPG', '.jpg'].includes(row.scope.suffix)
                "
                type="text"
                style="font-size: 12px"
                @click="preview(row.scope)"
              >
                预览
              </el-button>
            </template>
          </Table>
        </el-form-item>
      </el-form>

      <span
        slot="footer"
        class="dialog-footer"
        style="display: contents; margin-top: -30px"
      >
        <el-button @click="ANAndDohandleDialogClose">取 消</el-button>
        <el-button
          v-loading="loading"
          type="primary"
          @click="ANAndDOsubmitForm"
        >发 送</el-button
        >
      </span>
    </el-dialog>

    <ClearenceFileDialog
      :rowData="rowData"
      :dialogVisible="dialogVisible1"
      @cancel="dialogVisible1 = false"
    />
    <DetailDrawer
      :drawer="drawer1"
      :billType="active"
      :rowData="rowData"
      @close="drawer1 = false"
    />
  </div>
</template>

<script>
// 组件引入
const Table = () => import('@/components/table/table.vue')
const BaseTable = () => import('@/components/table/BaseTable.vue')
const BaseFilter = () => import('@/components/filter/BaseFilter')
const ClearenceFileDialog = () =>
  import('@/views/system/components/ClearenceFileDialog.vue')
const DetailDrawer = () => import('@/views/bill/components/DetailDrawer.vue')

import { getSupplierDropDownList } from '@/api/system'
import { validateArrEmail } from '@/utils/validate'
import {
  getFirmCodeOutputList,
  getAnDoStatusRecordPagedList,
  getMBLFileAnOrDoList,
  addAnAndDoFirmCode,
  sendAnEmail,
  sendDoEmail,
  insertDoFile,
  downLoadMBLFile
} from '@/api/bill'
import { derive } from '@/utils/common'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'ANDO',
  components: {
    Table,
    BaseTable,
    BaseFilter,
    ClearenceFileDialog,
    DetailDrawer
  },
  data() {
    return {
      isActive: false,
      active: 0, // 0: Sea, 1: Air
      rowData: {},
      mblIds: [],
      multipleSelection: [],
      drawer1: false,
      dialogVisible1: false,
      dialogFormVisible: false,
      dialogFormVisible1: false,
      supplierOptions: [],
      firmCodeOption: [],
      filePaths: {}, // 必须是 Object { filename: path }
      fileSoureCode: '',
      validationError: '',

      // 表格配置
      tableData: { fileds: [], columns: [], total: 0 },
      tableData1: {
        fileds: [
          { filed: 'fileName', label: '文件名', width: '' },
          { filed: 'typeName', label: '类型', width: '120' },
          {
            filed: 'createdOn',
            label: '上传时间',
            width: '140',
            formatter: (row) =>
              row.createdOn?.substring(0, 16).replace('T', ' ') || ''
          },
          { filed: 'createdName', label: '上传人', width: '100' },
          { filed: 'opt', label: '操作', width: '' }
        ],
        columns: [],
        total: 0,
        isShowIndex: false,
        isselection: true
      },

      // 分页与搜索
      pager: {
        PageIndex: 1,
        PageSize: 20,
        QueryParam: { SortField: 'eta', SortBy: 0 }
      },
      searchData: { search: '', mblNo: '', companyId: [] },

      // 状态统计
      status: 'All',
      tabNumer: [],
      form: { all: 0, one: 0, two: 0, three: 0 },

      // 表单数据
      title: '',
      form1: {
        firmCodeId: null,
        mblId: null,
        supplierClearenceId: null,
        firmCodeInformation: null,
        fordeLiveryTo: null,
        entry: null,
        remark: null
      },
      form2: {
        supplierClearenceId: null,
        mblId: null,
        receiver: null,
        cc: null,
        content: null,
        title: null
      },

      // 验证规则
      rules1: {
        firmCodeId: [
          { required: true, message: '请选择FirmCode', trigger: 'change' }
        ],
        supplierClearenceId: [
          { required: true, message: '请选择清关行', trigger: 'change' }
        ]
      },
      rules2: {
        supplierClearenceId: [
          { required: true, message: '请选择清关行', trigger: 'change' }
        ],
        receiver: [
          { required: true, validator: validateArrEmail, trigger: 'blur' }
        ],
        title: [{ required: true, message: '请填写主题', trigger: 'change' }],
        content: [
          { required: true, message: '请填写邮件内容', trigger: 'change' }
        ]
      },

      loading: false,
      loading1: false,
      loading2: false,
      btnloading: false,
      height: 0
    }
  },
  computed: {
    ...mapState({ deriveLoadingS: (state) => state.deriveLoading }),
    ...mapGetters(['companyDrapdown']),
    list() {
      return this.tableData // 直接返回 tableData
    },
    companyOptions() {
      return this.companyDrapdown
    },
    fileds() {
      const arr = [
        {
          filed: 'opt',
          label: '',
          width: '50px',
          isCustom: true,
          fixed: 'left'
        },
        { filed: 'anStatusName', label: 'AN发送状态', width: '80' },
        { filed: 'doStatusName', label: 'DO发送状态', width: '80' },
        { filed: 'companyName', label: '客户', width: '135' },
        { filed: 'mblNo', label: '主提单号', width: '160' },
        { filed: 'blNo', label: '分单号', width: '140' },
        { filed: 'eta', label: 'ETA', width: '90' },
        {
          filed: 'firmCode',
          label: 'firmCode',
          width: '80',
          formatter: (row) => row.firmCode || '待完善'
        },
        { filed: 'destinCode', label: '目的港', width: '70' },
        { filed: 'qty', label: '件数', width: '60' },
        {
          filed: 'isAN',
          label: 'AN',
          width: '40',
          formatter: (row) => (row.isAN ? '有' : '无')
        },
        {
          filed: 'isDo',
          label: 'DO',
          width: '40',
          formatter: (row) => (row.isDo ? '有' : '无')
        },
        {
          filed: 'isHold',
          label: '查验',
          width: '40',
          formatter: (row) => (row.isHold ? '是' : '否')
        },
        { filed: 'fileNumber', label: '文件数', width: '50', isCustom: true },
        { filed: 'supplierClearence', label: '清关行', width: '120' },
        { filed: 'currentStatusName', label: '清关状态', width: '80' },
        { filed: 'anSendOn', label: 'AN发送时间', width: '150' },
        { filed: 'doSendOn', label: 'DO发送时间', width: '150' },
        { filed: 'importerName', label: 'Importer', width: '120' },
        { filed: 'refuseReason', label: '拒绝原因', width: '120' },
        { filed: 'remark', label: '备注', width: '120' }
      ]
      // 海运模式下插入柜号
      if (this.active === 0) {
        arr.splice(5, 0, { filed: 'containerNo', label: '柜号', width: '120' })
      }
      return arr
    }
  },
  watch: {
    deriveLoadingS(newVal) {
      this.btnloading = newVal
    }
  },
  created() {
    this.initList()
  },
  mounted() {
    this.height = document.querySelector('.data').offsetHeight - 120
    if (!this.companyDrapdown.length) {
      this.$store.dispatch('getCompanyDrapdown')
    }
  },
  methods: {
    async download(v) {
      try {
        const res = await downLoadMBLFile({ guid: v.fileGuid })
        if (res) {
          const elink = document.createElement('a')
          elink.style.display = 'none'
          elink.href = res
          elink.type = 'download'
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        }
        console.log(res)
      } catch (error) {
        console.log(error)
      }
    },
    /** 初始化列表 */
    initList() {
      this.pager = {
        ...this.pager,
        QueryParam: {
          ...this.pager.QueryParam,
          mblType: this.active,
          statu: this.status
        }
      }
      this.getList(this.pager)
      this.getSupplierDropDownList()
    },
    async remoteMethod(query) {
      if (query !== '' && query.length > 2) {
        this.loading1 = true
        this.firmCodeOption = []
        const param = {
          keyword: query
        }
        await getFirmCodeOutputList(param).then((res) => {
          if (res.success) {
            res.data.forEach((item) => {
              const obj = {
                label: item.label,
                value: item.value
              }
              this.firmCodeOption.push(obj)
            })
          }
        })
        this.loading1 = false
      } else {
        this.firmCodeOption = []
        this.loading1 = false
      }
    },
    handleFocus() {
      // 清空当前的选项
      this.firmCodeOption = []
    },
    async getSupplierDropDownList() {
      try {
        const param = {
          scopValue: 18
        }
        const res = await getSupplierDropDownList(param)
        if (res.success) {
          this.supplierOptions = res.data
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    /** 处理 Tab 切换 */
    handleTabClick(indexOrEvent) {
      // 兼容点击事件对象和直接传入索引
      if (typeof indexOrEvent !== 'object') {
        this.active = indexOrEvent
      }
      this.initPage()
      this.searchList()
    },

    /** 搜索重置 */
    handleSearchReset() {
      this.isActive = false
      this.searchData = { search: '', mblNo: '', companyId: [] }
      this.initPage()
      this.searchList()
    },

    /** 搜索提交 */
    handleSearchOk() {
      this.initPage()
      this.searchList()
      this.isActive = true
    },

    /** 初始化分页参数 */
    initPage() {
      this.pager.PageIndex = 1
      this.pager.PageSize = 20
    },

    /** 搜索列表 */
    searchList() {
      const { search, mblNo, companyId } = this.searchData
      this.pager.QueryParam = {
        ...this.pager.QueryParam,
        status: this.status === 'All' ? undefined : this.status,
        mblType: this.active,
        companyId: companyId || undefined,
        Search: search || undefined,
        mblNo: mblNo || undefined
      }
      this.getList(this.pager)
    },

    /** 分页变化 */
    handlePageChange(pager) {
      this.pager.PageIndex = pager.pageIndex
      this.pager.PageSize = pager.pageSize
      this.searchList()
    },

    /** 双击行查看详情 */
    async handleRowDoubleClick(row) {
      await this.$store.dispatch('getAddressBookOptions', { type: -1 })
       this.rowData = {
        ...row,
        id: row.mblId,
        status: row.mblStatus
       }
      this.drawer1 = true
    },

    /** 表格多选 */
    handleSelectionChange(val) {
      this.multipleSelection = val
      this.mblIds = val.map((item) => item.mblId).filter(Boolean)
    },

    /** 处理操作命令 */
    handleCommand(key, row) {
      const handlers = {
        firmcode: () => this.AnAndDoFirmCodeClick(row),
        sendAnEmail: () => this.handleSendEmail(row, 'AN'),
        sendDoEmail: () => this.handleSendEmail(row, 'DO')
      }
      handlers[key]?.()
    },

    /** 通用发送邮件处理逻辑 */
    async handleSendEmail(row, type) {
      this.resetform2()
      if (type === 'DO') {
        // DO 发送前要生成DO文件
        if (row.id === '0') {
          return this.$message.error('请先给记录添加FirmCode操作！！')
        }
      const params = {
        mblId: row.mblId,
        firmCode: row.firmCode || ''
      }
        try {
          this.loading = true
          const res = await insertDoFile(params)
          if (res.success) {
            this.$message.success('DO附件生成成功')
          } else {
            this.$message.error(res.errorMessage)
            return
          }
        } catch (error) {
          this.$message.error('请求失败')
          return
        } finally {
          this.loading = false
        }
      }
      this.title = `发送${type}`
      this.fileSoureCode = type
      this.form2.mblId = row.mblId

      // 设置默认标题和内容
      this.setMailDefaults(row, type)

      // 预加载文件列表
      await this.getfileList(row)

      // 设置清关行（如果存在）
      if (
        row.supplierClearenceId &&
        this.supplierOptions.some((opt) => opt.id === row.supplierClearenceId)
      ) {
        this.form2.supplierClearenceId = row.supplierClearenceId
        this.supplierCodeChange(this.form2.supplierClearenceId)
      }

      this.dialogFormVisible1 = true
    },

    /** 设置邮件默认值 */
    setMailDefaults(row, type) {
      const isSea = this.active === 0
      const mblPart = `MBL:${row.mblNo}`
      const hblPart = row.blNo ? `, HBL:${row.blNo}` : ''
      const containerPart = isSea ? ` Container:${row.containerNo}` : ''

      this.form2.title = `${mblPart}${containerPart}${hblPart}`
      this.form2.content = `Dear all <p>Please see attached ${type}！</p>`
    },

    /** 重置表单1 */
    resetform1() {
      this.form1 = {
        firmCodeId: null,
        mblId: null,
        supplierClearenceId: null,
        firmCodeInformation: null,
        fordeLiveryTo: null,
        entry: null,
        remark: null
      }
    },

    /** 关闭 FirmCode 弹窗 */
    handleDialogClose() {
      this.dialogFormVisible = false
      this.resetform1()
      this.$refs.form1?.resetFields()
    },

    /** FirmCode 输入验证 */
    validateField1(value) {
      return this.validateFieldFormat(value, 1)
    },
    validateField2(value) {
      return this.validateFieldFormat(value, 2)
    },

    /** 通用字段格式验证 */
    validateFieldFormat(value, linesRequired) {
      if (!value || !value.trim()) return true
      const lineCount = value.trim().split('\n').length
      return lineCount >= linesRequired
    },

    /** 提交 FirmCode 表单 */
    async submitForm() {
      if (!this.validateField1(this.form1.firmCodeInformation)) {
        return this.$message.error('FirmCode替换信息格式异常')
      }
      if (!this.validateField2(this.form1.fordeLiveryTo)) {
        return this.$message.error('FORDELIVERYTO格式异常')
      }

      try {
        await this.$refs.form1.validate()
        this.loading2 = true
        const res = await addAnAndDoFirmCode(this.form1)
        if (res.success) {
          this.$message.success('操作成功')
          this.handleDialogClose()
          this.searchList()
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.loading2 = false
      }
    },

    /** 打开 FirmCode 编辑 */
    AnAndDoFirmCodeClick(row) {
      this.resetform1()
      this.form1.mblId = row.mblId
      // 回显数据逻辑
      Object.assign(this.form1, {
        firmCodeId: row.firmCodeId,
        firmCodeInformation: row.firmCodeInformation,
        fordeLiveryTo: row.fordeLiveryTo,
        entry: row.entry,
        remark: row.remark,
        supplierClearenceId: row.supplierClearenceId
      })

      // 特殊逻辑处理
      if (row.firmCodeId !== 1111 && this.active === 0) {
        this.remoteMethod(this.form1.firmCodeId)
      } else if (this.active === 1) {
        this.form1.firmCodeId = 1111
        this.remoteMethod('1111')
      }

      this.dialogFormVisible = true
    },

    /** 重置表单2 (修复了原代码中的 supplierCode 错误) */
    resetform2() {
      this.form2 = {
        supplierClearenceId: null,
        mblId: null,
        receiver: null,
        cc: null,
        content: null,
        title: null
      }
      this.filePaths = {} // 重置文件路径
    },

    /** 关闭发送邮件弹窗 */
    ANAndDohandleDialogClose() {
      this.dialogFormVisible1 = false
      this.resetform2()
      this.$refs.form2?.resetFields()
    },

    /** 获取文件列表 */
    async getfileList(row) {
      try {
        const params = { fileSoureCode: this.fileSoureCode, mblId: row.mblId }
        const res = await getMBLFileAnOrDoList(params)
        this.tableData1.columns = res.data || []
      } catch (error) {
        console.error('获取文件列表失败:', error)
        this.tableData1.columns = []
      }
    },

    /** 预览文件 */
    preview(item) {
      window.open(item.filePath)
    },

    /** 选择文件变更 */
    selectionchange2(val) {
      this.filePaths = val.reduce((acc, item) => {
        acc[item.fileName] = item.filePath
        return acc
      }, {})
      this.multipleSelection = val
    },

    /** 全选行 */
    selectAllRows() {
      this.$nextTick(() => {
        this.$refs.customTable?.selectAllRows()
      })
    },

    /** 清关行改变 */
    supplierCodeChange(val) {
      const supplier = this.supplierOptions.find((item) => item.id === val)
      this.form2.receiver = supplier?.email || ''
      this.form2.cc = supplier?.email || ''
    },

    /** 邮箱列表验证 */
    validateEmailList() {
      this.validationError = ''
      const cc = this.form2.cc?.trim() || ''

      if (cc.includes(' ')) {
        this.validationError = '电子邮件地址中不能包含空格'
        return
      }

      if (!cc) return

      const emails = cc
        .split(/[,;，；]/)
        .filter((email) => email.trim() !== '')
      for (const email of emails) {
        if (!this.isValidEmail(email.trim())) {
          this.validationError = '电子邮件格式不正确'
          return
        }
      }
    },

    /** 单个邮箱验证 */
    isValidEmail(email) {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      return emailRegex.test(email.trim())
    },

    /** 提交发送邮件 */
    async ANAndDOsubmitForm() {
      this.validateEmailList()
      if (this.validationError) return
      if (this.multipleSelection.length < 1) {
        return this.$message.error('请选择至少1个附件文件')
      }

      try {
        await this.$refs.form2.validate()
        this.loading = true

        // 确保 filePaths 是最新的 (防御性编程)
        this.filePaths = this.multipleSelection.reduce((acc, item) => {
          acc[item.fileName] = item.filePath
          return acc
        }, {})

        const items = {
          ...this.form2,
          filePaths: this.filePaths
        }

        const apiCall = this.title.includes('AN')
          ? sendAnEmail(items)
          : sendDoEmail(items)
        const res = await apiCall

        if (res.success) {
          this.$message.success(`发送${this.title}成功`)
          this.ANAndDohandleDialogClose()
          this.searchList()
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.error('提交失败:', error)
      } finally {
        this.loading = false
      }
    },

    /** 获取主列表数据 */
    async getList(params) {
      try {
        const res = await getAnDoStatusRecordPagedList(params)
        if (res.success) {
          this.tableData.columns = res.data.list.map((item) => ({
            ...item,
            eta: item.eta?.substring(0, 10),
            etd: item.etd?.substring(0, 10),
            entryDate: item.entryDate?.substring(0, 10) || '',
            releaseDate: item.releaseDate?.substring(0, 10) || '',
            uploadedDate: item.uploadedDate?.substring(0, 10) || ''
          }))
          this.tableData.total = res.data.total
          this.updateTabNumbers(res.data.tabNumer || [])
          this.tabNumer = res.data.tabNumer || []
        } else {
          this.$message.error(res.errorMessage || '获取列表失败')
        }
      } catch (error) {
        this.$message.error('网络错误，请稍后再试')
      }
    },

    /** 更新 Tab 统计数字 */
    updateTabNumbers(tabNumer) {
      // 初始化
      Object.assign(this.form, { all: 0, one: 0, two: 0, three: 0 })

      const extractQty = (items) => {
        items.forEach((item) => {
          if (item.subTab) {
            extractQty(item.subTab)
          } else {
            if (item.type === 0) this.form.one += item.qty
            if (item.type === 1) this.form.two += item.qty
            if (item.type === 2) this.form.three += item.qty
          }
        })
      }

      if (Array.isArray(tabNumer)) {
        extractQty(tabNumer)
        this.form.all = this.form.one + this.form.two + this.form.three
      }
    },

    /** 导出数据 */
    async handleExport() {
      const params = {
        status: this.status === 'All' ? undefined : this.status,
        mblType: this.active,
        Search: this.searchData.search || undefined,
        mblNo: this.searchData.mblNo || undefined
      }

      this.btnloading = true
      try {
        await derive('AnDoStatusRecord/export', 'post', params, null)
      } catch (error) {
        this.$message.error('导出失败')
      } finally {
        this.btnloading = false
      }
    },

    /** 查看文件 */
    viewFile(row) {
      this.rowData = row
      this.dialogVisible1 = true
    }
  }
}
</script>

<style lang="less" scoped>
.view-container {
  width: 100%;
  padding: 0 10px;
  height: 100%;
  background: #fff;
  box-sizing: border-box;
  overflow: auto;

  .header {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .tabItem {
      padding: 15px 20px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      line-height: 20px;
      cursor: pointer;
      box-sizing: border-box;
    }

    .active {
      color: rgb(18, 88, 188);
    }

    .type-tab {
      display: flex;
      align-items: center;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 12px;
      color: #999999;
      border-radius: 2px 2px 2px 2px;
      overflow: hidden;

      & > span {
        height: 30px;
        padding: 7px 12px;
        box-sizing: border-box;
        background: #f7f7f7;
        cursor: pointer;

        &.active {
          color: #ffffff;
          background: rgb(18, 88, 188);
        }
      }
    }
  }

  .optheader {
    display: flex;

    & > div + div {
      margin-left: 8px;
    }

    .search {
      position: relative;
      display: flex;
      width: 200px;

      .input-search {
        width: 170px;
        height: 30px !important;

        /deep/ .el-input__inner {
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }
      }

      .btn-search {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 30px;
        height: 30px;
        border: 1px solid #dbe4f2;
        border-left: 0;
        border-radius: 0 4px 4px 0;
        box-sizing: border-box;
        cursor: pointer;
      }
    }

    /deep/ .el-input__inner {
      height: 30px;
    }

    .add {
      width: 84px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgb(18, 88, 188);
      border-radius: 4px 4px 4px 4px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      cursor: pointer;
      line-height: 24px;

      .icon {
        font-size: 20px;
      }
    }

    .filter {
      width: 84px;
      height: 32px;
      border-radius: 4px 4px 4px 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid rgb(18, 88, 188);
      border-color: rgba(35, 149, 243, 0.4);
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: rgb(18, 88, 188);
      cursor: pointer;
      line-height: 24px;
    }
  }

  .opt {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .btn {
    width: 80px;
    height: 30px;
    background: rgb(18, 88, 188);
    border-radius: 4px;
    opacity: 1;
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
  }

  .icon {
    font-size: 20px;
    vertical-align: text-top;
  }

  .data {
    width: 100%;
    height: calc(100% - 50px);

    & .fTable {
      border-top: 1px solid #ebeef5;
      box-sizing: border-box;
    }
  }

  .circle {
    width: 6px;
    height: 6px;
    opacity: 1;
    display: inline-block;
    border-radius: 50%;
    margin-right: 6px;
  }

  .table-opt:deep(.el-button) {
    padding: 0;
  }

  .status {
    width: 28px;
    height: 19px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: rgb(18, 88, 188);
    line-height: 20px;
    margin-left: 5px;
    margin-right: 31px;
  }
}

:deep(.el-upload-dragger) {
  background-color: #fff;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  box-sizing: border-box;
  width: 470px;
  height: 100px;
  text-align: center;
  cursor: pointer;
  overflow: hidden;
}

:deep(.el-upload-list) {
  float: none;
}
</style>
